module.exports = __webpack_public_path__ + "media/images/icon__externalLink-6f8e492189a1a0c1280fe01f79a2ad79.png";